import React from 'react';
import { Line } from 'react-chartjs-2';
import PlayerContext from '../../../../playerContext';
import _ from "lodash"
import { Label } from 'semantic-ui-react';

const state = {
    //   labels: ['January', 'February', 'March',
    //            'April', 'May'],

}

// const arousalColor = 'rgb(255, 99, 132)';
const arousalColor = '#db2828';

// const valenceColor = 'rgb(255, 205, 86)';
const valenceColor = '#fbbd08';

// 	orange: 'rgb(255, 159, 64)',
// 	yellow: 'rgb(255, 205, 86)',

export default class StoryGraph extends React.Component {
    static contextType = PlayerContext

    timeToCroppedMetadata = (time) => {
        const playerStatus = this.context
        return _.filter(playerStatus.metadata, (instance) => {
            // console.log(instance.time ,time)
            return instance.time <= time + 6
        }).filter(function(value, index, Arr) {
            return index % 5 === 0;
        });
    }

    render() {
        const playerStatus = this.context

        const currentData = playerStatus.metadata ? this.timeToCroppedMetadata(playerStatus.currentSeconds) : null
        const currentArousal = currentData ? currentData.map((instance) => instance.sound_arousal) : []
        const currentValence = currentData ? currentData.map((instance) => instance.sound_valence) : []
        const currentLabels = currentData ? currentData.map((instance) => instance.time) : []

        return (
            <div style={{"width":"190px"}}>
                <Line
                    height={150}

                    data={{
                        labels: currentLabels,
                        datasets: [
                            {
                                label: 'Arousal',
                                fill: true,
                                //   lineTension: 0.5,
                                backgroundColor: arousalColor,
                                borderColor: arousalColor,
                                //   borderWidth: 2,
                                data: currentArousal
                            },
                            {
                                label: 'Valence',
                                fill: true,
                                //   lineTension: 0.5,
                                backgroundColor: valenceColor,
                                borderColor: valenceColor,
                                //   borderWidth: 2,
                                data: currentValence
                            }
                        ]
                    }}
                    options={{
                        scales: {
                            xAxes: [{
                                gridLines: {
                                    color: "rgba(0, 0, 0, 0)",
                                },
                                ticks: {
                                    display: false
                                }

                            }],
                            yAxes: [{
                                gridLines: {
                                    color: "rgba(0, 0, 0, 0)",
                                },
                                type: 'linear',
                                ticks: {
                                    display: false
                                }

                            }]
                        },
                        title: {
                            display: false,
                            text: '',
                            fontSize: 20
                        },
                        legend: {
                            display: false,
                            position: 'bottom'
                        }
                    }}
                />
                <Label style={{ "color": arousalColor }} size="tiny" color="red" >
                    Arousal
                </Label>
                <Label as='a' style={{ "color": valenceColor }} size="tiny" color="yellow" >
                    Valence
                </Label>
            </div>
        );
    }
}
